import { ReportImg } from "@/components/report/commons/ReportImg";
import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface CircadianRhythmDialogProps extends HelpDialogLayoutProps {}
export default function CircadianRhythmDialog(
  props: CircadianRhythmDialogProps
) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠と体内時計の関係</Typography>
          <BodyTypographies
            contents={[
              "睡眠と体内時計は密接に結びついています。休日に睡眠不足を解消しようと朝寝坊をすると、体内時計がずれ、睡眠・覚醒リズムが乱れる原因になります。これにより、少なくとも翌週の平日の中頃までは日中に強い眠気や倦怠感を感じたり、休日の夜に寝付く時間が遅れたりすることが観察されています。また習慣的な乱れは、肥満、うつ病などの疾患リスクを上げることも指摘されています。",
              "",
              "こうした影響を避けるためには、平日と休日で起床時刻をできるだけ揃えることが重要です。平日に15分ずつでもいいので睡眠時間を延ばせないかを再検討してみてください。どうしても休日に長く眠りたい場合は、起床時刻を遅らせるのではなく、前日の就寝時刻を早めることで対応するのがおすすめです。起床時刻を遅らせる場合は最大でも2時間以内にしましょう。",
              "例えば、平日の睡眠時間が5時間で休日は8時間眠りたい、と言う場合は、前日に1時間早めに寝る+起床時刻を2時間遅らせる、で+3時間確保することができます。",
              <ReportImg
                image_name="image_report_circadian_rhythm.png"
                style={{ width: "100%", paddingTop: "24px" }}
              />,
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">
            体内時計を整えるための工夫
          </Typography>
          <BodyTypographies
            contents={[
              "休日も朝起きたら太陽の光をしっかり浴びることで、体内時計をリセットできます。これにより、睡眠・覚醒リズムが整いやすくなり、日中の活動がスムーズになり、夜の睡眠の質も向上します。日光浴は、体内時計を調整する自然な方法として非常に効果的です。特に夜更かしや時差ボケ等でずれてしまったリズムを戻したい時、シフトの切り替えで新しいリズムに適応したい時、年齢とともに睡眠の質が落ちていると感じられる時は、起床時に積極的に外に出て運動するなど、日光浴をする機会を作りましょう。",
            ]}
          />
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
